<template>
  <table class="adminStatsForm">
    <tr>
      <td>
        <div class="flex-fJstart-fAstart">
          <label>Agence :</label>
          <vue-select
            multiple
            :options="agencesOptions"
            label="libelle_agence"
            :reduce="entry => entry.code_agence"
            v-model="agences"
          >
            <span slot="no-options">Aucune agence correspondante à votre recherche</span>
          </vue-select>
        </div>
      </td>
      <td colspan="2">
        <div class="flex-wrap-fJstart-fAstart oneclick">
          <div class="flex-fJstart-fAstart">
            <button
              @click="setDateAujourdhui"
              :disabled="fetching"
            >
              Aujourd'hui
            </button>
            <button
              @click="setDateCetteSemaine"
              :disabled="fetching"
            >
              Cette semaine
            </button>
            <button
              @click="setDateCeMois"
              :disabled="fetching"
            >
              Ce mois
            </button>
            <button
              @click="setDateCetteAnnee"
              :disabled="fetching"
            >
              Cette année
            </button>
          </div>
          <div class="flex-fJstart-fAstart">
            <button
              @click="setDateHier"
              :disabled="fetching"
            >
              Hier
            </button>
            <button
              @click="setDateSemaineAvant"
              :disabled="fetching"
            >
              Semaine -1
            </button>
            <button
              @click="setDateMoisAvant"
              :disabled="fetching"
            >
              Mois -1
            </button>
            <button
              @click="setDateAnneeAvant"
              :disabled="fetching"
            >
              Année -1
            </button>
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <div class="flex-fJstart-fAstart">
          <label>Grouper par :</label>
          <vue-select
            :options="echelleOptions"
            label="label"
            :reduce="entry => entry.code"
            v-model="echelle"
            :clearable="false"
          />
        </div>
      </td>
      <td>
        <div class="flex-fJstart-fAcenter datepicker">
          <span>Du</span>
          <input
            type="date"
            v-model="dateDebut"
            required="required"
          >
          <span>Au</span>
          <input
            type="date"
            v-model="dateFin"
            required="required"
          >
        </div>
      </td>
      <td />
    </tr>
    <tr>
      <td>
        <div class="flex-fJstart-fAstart">
          <label>Client :</label>
          <vue-select
            :options="clientsArray"
            v-model="client"
            label="libelle"
            :reduce="entry => entry.code"
          >
            <span slot="no-options">Aucun client correspondant à votre recherche</span>
          </vue-select>
        </div>
      </td>
      <td>
        <div class="flex-fJstart-fAstart">
          <label>Type client :</label>
          <vue-select
            :options="typesClientArray"
            v-model="typeClient"
            label="LIB"
            :reduce="entry => entry.VAL"
          >
            <template
              slot="option"
              slot-scope="option"
            >
              {{ option.LIB }} ({{ option.VAL }})
            </template>
            <template
              slot="selected-option"
              slot-scope="option"
            >
              {{ option.LIB }} ({{ option.VAL }})
            </template>
            <span slot="no-options">Aucun client correspondant à votre recherche</span>
          </vue-select>
        </div>
      </td>
      <td />
    </tr>
    <tr>
      <td>
        <button @click="getCsv">Exporter au format csv</button>
      </td>
      <td>
        <button
          @click="rechercher"
          :disabled="fetching"
        >
          {{ rechercheLabel }}
        </button>
      </td>
      <td />
    </tr>
  </table>
</template>

<script>
import vueSelect from 'vue-select'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    'vue-select': vueSelect
  },
  async created() {
    await this.getClients()
    await this.getAgences()
    await this.getTypesClient()

    //init date values
    let date = new Date()
    this.dateFin = this.formatDate(date)
    date.setDate(date.getDate() - 29)
    this.dateDebut = this.formatDate(date)

    this.rechercher()
  },
  data() {
    return {
      agences: [],
      client: null,
      typeClient: null,
      dateDebut: null,
      dateFin: null,
      echelle: 'jour'
    }
  },
  computed: {
    ...mapGetters([
      'agencesOptions',
      'clients',
      'typesClient',
      'fetching'
    ]),
    echelleOptions: function() {
      return [
        { code: 'heure', label: 'Heure' },
        { code: 'jour', label: 'Jour' },
        { code: 'semaine', label: 'Semaine' },
        { code: 'mois', label: 'Mois' }
      ]
    },
    clientsArray: function() {
      return Object.keys(this.clients).map((key) => this.clients[key])
    },
    typesClientArray: function() {
      return Object.keys(this.typesClient).map((key) => this.typesClient[key])
    },
    rechercheLabel: function () {
      if (this.fetching) {
        return 'Actualisation en cours'
      } else {
        return 'Valider'
      }
    }
  },
  methods: {
    ...mapActions([
      'getAgences',
      'getClients',
      'getTypesClient',
      'updateStats'
    ]),
    rechercher: function() {
      let params = { agences: this.agences, dateDebut: this.dateDebut, dateFin: this.dateFin, echelle: this.echelle, client: this.client, typeClient: this.typeClient }
      this.updateStats(params)
    },
    formatDate: function(date) {
      let month = '' + (date.getMonth() + 1),
          day = '' + date.getDate(),
          year = date.getFullYear()

      if (month.length < 2)
        month = '0' + month
      if (day.length < 2)
        day = '0' + day

      return [year, month, day].join('-')
    },
    getCsv: function() {
      let route = '/admin/statistiques/csv'
      let params = 'echelle=' + this.echelle + '&' + 'dateDebut=' + this.dateDebut + '&' + 'dateFin=' + this.dateFin
      if (this.client !== null) {
        params += '&' + 'client=' + this.client
      }
      if (this.typeClient !== null) {
        params += '&' + 'typeClient=' + this.typeClient
      }
      for (let agence of this.agences) {
        params += '&' + 'agences[]=' + agence
      }
      window.location.href = route + '?' + params
    },
    setDateAujourdhui: function() {
      let date = this.formatDate(new Date())
      this.dateFin = date
      this.dateDebut = date
      this.echelle = 'heure'

      this.rechercher()
    },
    setDateCetteSemaine: function() {
      let dateDebut = new Date()
      this.dateFin = this.formatDate(dateDebut)
      let dateFin = new Date()
      let day = dateFin.getDay()
      let diff = day - (day === 0 ? 6:1) // 0=dimanche
      dateFin.setDate(dateFin.getDate() - diff)
      this.dateDebut = this.formatDate(dateFin)
      this.echelle = 'jour'

      this.rechercher()
    },
    setDateCeMois: function() {
      let dateFin = new Date()
      this.dateFin = this.formatDate(dateFin)
      let dateDebut = new Date()
      dateDebut.setDate(1)
      this.dateDebut = this.formatDate(dateDebut)
      this.echelle = 'semaine'

      this.rechercher()
    },
    setDateCetteAnnee: function() {
      let dateFin = new Date()
      this.dateFin = this.formatDate(dateFin)
      let dateDebut = new Date()
      dateDebut.setDate(1)
      dateDebut.setMonth(0)
      this.dateDebut = this.formatDate(dateDebut)
      this.echelle = 'mois'

      this.rechercher()
    },
    setDateHier: function() {
      let date = new Date()
      date.setDate(date.getDate()-1)
      this.dateFin = this.formatDate(date)
      this.dateDebut = this.formatDate(date)
      this.echelle = 'heure'

      this.rechercher()
    },
    setDateSemaineAvant: function() {
      let dateFin = new Date()
      let day = dateFin.getDay()
      let diff = day - (day === 0 ? 5:0) // 0=dimanche
      dateFin.setDate(dateFin.getDate() - diff)
      this.dateFin = this.formatDate(dateFin)
      let dateDebut = new Date()
      dateDebut.setDate(dateFin.getDate() - 6)
      this.dateDebut = this.formatDate(dateDebut)
      this.echelle = 'jour'

      this.rechercher()
    },
    setDateMoisAvant: function() {
      let dateDebut = new Date()
      dateDebut.setDate(1)
      dateDebut.setMonth(dateDebut.getMonth()-1)
      this.dateDebut = this.formatDate(dateDebut)
      let dateFin = new Date()
      dateFin.setDate(1)
      dateFin.setDate(dateFin.getDate()-1)
      this.dateFin = this.formatDate(dateFin)
      this.echelle = 'semaine'

      this.rechercher()
    },
    setDateAnneeAvant: function() {
      let dateDebut = new Date()
      dateDebut.setDate(1)
      dateDebut.setMonth(0)
      dateDebut.setFullYear(dateDebut.getFullYear()-1)
      this.dateDebut = this.formatDate(dateDebut)
      let dateFin = new Date()
      dateFin.setMonth(11)
      dateFin.setDate(31)
      dateFin.setFullYear(dateFin.getFullYear()-1)
      this.dateFin = this.formatDate(dateFin)
      this.echelle = 'mois'

      this.rechercher()
    }
  }
}
</script>
